/* Maison Avadoté — theme.js
   Dual clock + weather, drop countdown, swatches, FAQ accordion,
   quote rotation, and a real Shopify Ajax Cart (add / change / refresh
   via the Section Rendering API).
*/

document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------
     Dual clock (city names + timezones come from section settings
     via data-city1 / data-city2 attributes on .announce / footer)
  --------------------------------------------------------- */
  function tickClocks () {
    var fmt = function (tz) {
      try {
        return new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit' }).format(new Date());
      } catch (e) { return '--:--'; }
    };
    document.querySelectorAll('[data-clock-tz]').forEach(function (el) {
      el.textContent = fmt(el.getAttribute('data-clock-tz'));
    });
  }
  tickClocks();
  setInterval(tickClocks, 15000);

  /* ---------------------------------------------------------
     Live weather via Open-Meteo (free, no key, CORS-enabled)
     Reads lat/lng from data attributes set by section settings.
  --------------------------------------------------------- */
  function tickWeather () {
    document.querySelectorAll('[data-weather-lat]').forEach(function (el) {
      var lat = el.getAttribute('data-weather-lat');
      var lng = el.getAttribute('data-weather-lng');
      if (!lat || !lng) return;
      fetch('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lng + '&current=temperature_2m')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var temp = Math.round(data.current.temperature_2m) + '°C';
          document.querySelectorAll('[data-weather-for="' + el.getAttribute('data-weather-for') + '"]').forEach(function (t) {
            t.textContent = temp;
          });
        })
        .catch(function (err) { console.warn('Weather fetch failed, leaving placeholder', err); });
    });
  }
  tickWeather();
  setInterval(tickWeather, 15 * 60 * 1000);

  /* ---------------------------------------------------------
     Drop countdown — reads an ISO date from the hero section's
     data-drop-deadline attribute (set via theme editor)
  --------------------------------------------------------- */
  var dropTimerEl = document.getElementById('dropTimer');
  if (dropTimerEl) {
    var deadlineAttr = dropTimerEl.closest('.hero').getAttribute('data-drop-deadline');
    var deadline = deadlineAttr ? new Date(deadlineAttr) : null;
    if (deadline && !isNaN(deadline.getTime())) {
      var tickCountdown = function () {
        var diff = Math.max(0, deadline - new Date());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        dropTimerEl.textContent = d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
      };
      tickCountdown();
      setInterval(tickCountdown, 1000);
    } else {
      dropTimerEl.closest('.hero__drop').style.display = 'none';
    }
  }

  /* ---------------------------------------------------------
     Swatch selection — updates the card's "add to cart" target
     variant id when a product has a Color (or similar) option
  --------------------------------------------------------- */
  document.querySelectorAll('.swatches').forEach(function (group) {
    group.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        group.querySelectorAll('.swatch').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
        var card = group.closest('.product-card');
        var quickAdd = card && card.querySelector('[data-add-to-cart]');
        if (quickAdd && sw.getAttribute('data-variant-id')) {
          quickAdd.setAttribute('data-variant-id', sw.getAttribute('data-variant-id'));
        }
      });
    });
  });

  /* ---------------------------------------------------------
     FAQ accordion
  --------------------------------------------------------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('button');
    var panel = item.querySelector('.panel');
    btn.addEventListener('click', function () {
      var isOpen = item.getAttribute('data-open') === 'true';
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.setAttribute('data-open', 'false');
        i.querySelector('.panel').style.maxHeight = null;
      });
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ---------------------------------------------------------
     Quote strip rotation
  --------------------------------------------------------- */
  var quoteItems = document.querySelectorAll('.quote-strip__item');
  var quoteDots = document.querySelectorAll('.quote-dots button');
  if (quoteItems.length > 1) {
    var qIndex = 0;
    var showQuote = function (i) {
      quoteItems.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      quoteDots.forEach(function (el, idx) { el.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
      qIndex = i;
    };
    quoteDots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { showQuote(idx); });
    });
    setInterval(function () { showQuote((qIndex + 1) % quoteItems.length); }, 6000);
  }

  /* ---------------------------------------------------------
     Video gallery — one clip on screen, advancing to the next
     when it ends (or on a timer for external/poster slides)
  --------------------------------------------------------- */
  document.querySelectorAll('[data-video-rotator]').forEach(function (stage) {
    var slides = stage.querySelectorAll('[data-video-slide]');
    if (slides.length < 2) return; // a lone video just loops on its own

    var isAutoplay = stage.getAttribute('data-playback') === 'autoplay';
    var vIndex = 0;
    var vTimer = null;

    var showVideo = function (i) {
      if (vTimer) { clearTimeout(vTimer); vTimer = null; }
      vIndex = i;

      slides.forEach(function (el, idx) {
        var on = idx === i;
        el.classList.toggle('is-active', on);
        var vid = el.querySelector('video');
        if (!vid) return;
        if (on) {
          try { vid.currentTime = 0; } catch (e) {}
          if (isAutoplay) {
            var played = vid.play();
            if (played && played.catch) played.catch(function () {});
          }
        } else {
          vid.pause();
        }
      });

      // slides with no <video> (YouTube/Vimeo embed or a still) can't
      // report 'ended', so they hand off on a timer instead
      if (isAutoplay && !slides[i].querySelector('video')) {
        vTimer = setTimeout(nextVideo, 7000);
      }
    };

    var nextVideo = function () { showVideo((vIndex + 1) % slides.length); };

    slides.forEach(function (el) {
      var vid = el.querySelector('video');
      if (!vid) return;
      vid.addEventListener('ended', function () {
        if (el.classList.contains('is-active')) nextVideo();
      });
    });

    showVideo(0);
  });

  /* ---------------------------------------------------------
     Lang toggle (visual state only — wire to /en, /fr URLs
     once Shopify Markets/translations are set up)
  --------------------------------------------------------- */
  document.querySelectorAll('.lang-toggle button').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.lang-toggle button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
    });
  });

  /* ---------------------------------------------------------
     Scroll reveal
  --------------------------------------------------------- */
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
    });
  }, { threshold: .15 });
  document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });

  /* ===========================================================
     REAL SHOPIFY CART (Ajax Cart API + Section Rendering API)
     =========================================================== */
  var cartDrawer = document.getElementById('CartDrawer');
  var scrim = document.getElementById('scrim');

  function openCartDrawer () {
    if (cartDrawer) cartDrawer.setAttribute('data-open', 'true');
    if (scrim) scrim.setAttribute('data-open', 'true');
  }
  function closeCartDrawer () {
    if (cartDrawer) cartDrawer.setAttribute('data-open', 'false');
    if (scrim) scrim.setAttribute('data-open', 'false');
  }
  function bindCartDrawerEvents () {
    cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    var closeBtn = cartDrawer.querySelector('#cartClose');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    cartDrawer.querySelectorAll('[data-remove-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromCart(btn.getAttribute('data-remove-line'));
      });
    });
  }

  function updateBagCount (count) {
    document.querySelectorAll('.bag-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------------------------------------------------------
     Set discount — detects paired products in cart and
     auto-applies AVADOTESET (10% off) at checkout
  --------------------------------------------------------- */
  /* Set discount is an automatic Shopify discount now (The Set: 10% off any two
     pieces in the the-sets collection). The cart drawer renders its own nudge and
     confirmation in Liquid, and checkout applies it automatically, so there is
     nothing to do here and no code is appended to the checkout URL. */
  function checkPairsDiscount () {}

  function refreshCartDrawer () {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html || !cartDrawer) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('#CartDrawer');
        if (fresh) {
          cartDrawer.replaceWith(fresh);
          cartDrawer = fresh;
          bindCartDrawerEvents();
        }
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateBagCount(cart.item_count); });
  }

  function addToCart (variantId, qty) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(refreshCartDrawer)
      .then(function () { checkPairsDiscount(); openCartDrawer(); })
      .catch(function (err) { console.error('Add to cart failed', err); });
  }

  function removeFromCart (line) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(refreshCartDrawer)
      .then(checkPairsDiscount)
      .catch(function (err) { console.error('Remove from cart failed', err); });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.hasAttribute('disabled')) return;
      var qty = 1;
      var qtySelector = btn.getAttribute('data-qty-input');
      if (qtySelector) {
        var qtyEl = document.querySelector(qtySelector);
        if (qtyEl) qty = parseInt(qtyEl.value, 10) || 1;
      }
      addToCart(btn.getAttribute('data-variant-id'), qty);
    });
  });

  /* ---------------------------------------------------------
     Product page — gallery thumbnails
  --------------------------------------------------------- */
  var mainImageTag = document.getElementById('ProductMainImageTag');
  document.querySelectorAll('.product__thumbs .ph').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product__thumbs .ph').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImageTag) mainImageTag.src = thumb.getAttribute('data-full');
    });
  });

  /* ---------------------------------------------------------
     Product page — live variant picker
  --------------------------------------------------------- */
  var variantsJSONEl = document.getElementById('ProductVariantsJSON');
  if (variantsJSONEl) {
    var variants = JSON.parse(variantsJSONEl.textContent);
    var optionGroups = document.querySelectorAll('.option-selector');
    var addToCartBtn = document.getElementById('ProductAddToCart');
    var addToCartLabel = document.getElementById('ProductAddToCartLabel');
    var priceEl = document.getElementById('ProductPrice');
    var availabilityEl = document.getElementById('ProductAvailability');

    function currentSelection () {
      var selected = [];
      optionGroups.forEach(function (group) {
        var pressed = group.querySelector('.option-pill[aria-pressed="true"]');
        selected.push(pressed ? pressed.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findMatchingVariant () {
      var selected = currentSelection();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function formatMoney (cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD' });
    }

    function updateForVariant () {
      var variant = findMatchingVariant();
      if (!variant) return;
      if (addToCartBtn) addToCartBtn.setAttribute('data-variant-id', variant.id);
      if (priceEl) {
        priceEl.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? '<s>' + formatMoney(variant.compare_at_price) + '</s> ' + formatMoney(variant.price)
          : formatMoney(variant.price);
      }
      if (variant.available) {
        if (addToCartBtn) { addToCartBtn.removeAttribute('disabled'); }
        if (addToCartLabel) addToCartLabel.textContent = 'Add to Bag';
        if (availabilityEl) { availabilityEl.textContent = 'In stock, ready to ship'; availabilityEl.classList.remove('is-sold-out'); }
      } else {
        if (addToCartBtn) { addToCartBtn.setAttribute('disabled', 'disabled'); }
        if (addToCartLabel) addToCartLabel.textContent = 'Sold Out';
        if (availabilityEl) { availabilityEl.textContent = 'Currently sold out'; availabilityEl.classList.add('is-sold-out'); }
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.option-pill').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          updateForVariant();
        });
      });
    });
  }

  /* ---------------------------------------------------------
     Lookbook auto-advance carousel (mobile only, transform-based)
  --------------------------------------------------------- */
  var lookbookScroll = document.querySelector('.lookbook__scroll');
  if (lookbookScroll && window.innerWidth <= 760) {
    var lookbookRows = lookbookScroll.querySelectorAll('.lookbook__row');
    if (lookbookRows.length > 1) {
      var lookIndex = 0;
      setInterval(function () {
        lookIndex = (lookIndex + 1) % lookbookRows.length;
        lookbookScroll.style.transform = 'translateX(-' + (lookIndex * 100) + '%)';
      }, 4000);
    }
  }

  var cartToggle = document.getElementById('cartToggle');
  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
      checkPairsDiscount();
    });
  }
  if (scrim) scrim.addEventListener('click', closeCartDrawer);
  /* Shared with snippets/set-complete.liquid (Add the set). */
  window.AvadoteCart = { refresh: refreshCartDrawer, open: openCartDrawer };
  bindCartDrawerEvents();

  /* ---------------------------------------------------------
     Mobile menu toggle — hamburger ↔ X + slide-down dropdown
  --------------------------------------------------------- */
  var menuToggle = document.querySelector('.menu-toggle');
  var siteHeader = document.querySelector('.site-header');
  var mobileNav  = document.querySelector('.mobile-nav');
  if (menuToggle && siteHeader) {
    menuToggle.addEventListener('click', function () {
      var isOpen = siteHeader.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      if (mobileNav) mobileNav.setAttribute('aria-hidden', !isOpen);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && siteHeader.classList.contains('menu-open')) {
        siteHeader.classList.remove('menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        if (mobileNav) mobileNav.setAttribute('aria-hidden', 'true');
      }
    });
  }
});

/* ---------------------------------------------------------
   Size guide — inch/cm toggle.
   Drives every [data-size-guide] block on the page, so the
   product-page modal and /pages/size-guide share this one
   implementation. EDIT MEASUREMENTS HERE — the markup lives
   in snippets/size-guide-table.liquid.
--------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var SIZE_DATA = [
    { size: 'XS', bust: 30, waist: 24, hip: 34 },
    { size: 'XS', bust: 32, waist: 26, hip: 36 },
    { size: 'S',  bust: 34, waist: 28, hip: 38 },
    { size: 'S',  bust: 36, waist: 30, hip: 42 },
    { size: 'M',  bust: 38, waist: 32, hip: 44 },
    { size: 'M',  bust: 40, waist: 34, hip: 46 },
    { size: 'L',  bust: 42, waist: 36, hip: 48 },
    { size: 'L',  bust: 44, waist: 38, hip: 50 },
    { size: 'XL', bust: 46, waist: 40, hip: 52 },
    { size: 'XL', bust: 48, waist: 42, hip: 54 }
  ];

  function toCm (inches) { return Math.round(inches * 2.54 * 10) / 10; }

  document.querySelectorAll('[data-size-guide]').forEach(function (root) {
    var tbody = root.querySelector('[data-size-guide-tbody]');
    var buttons = root.querySelectorAll('.size-guide-unit-btn');
    if (!tbody) return;

    function render (unit) {
      tbody.innerHTML = SIZE_DATA.map(function (row) {
        var suffix = unit === 'cm' ? ' cm' : '"';
        var bust  = unit === 'cm' ? toCm(row.bust)  : row.bust;
        var waist = unit === 'cm' ? toCm(row.waist) : row.waist;
        var hip   = unit === 'cm' ? toCm(row.hip)   : row.hip;
        return '<tr><td>' + row.size + '</td><td>' + bust + suffix +
               '</td><td>' + waist + suffix + '</td><td>' + hip + suffix + '</td></tr>';
      }).join('');
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        render(btn.dataset.unit);
      });
    });

    render('in');
  });
});

/* ---------------------------------------------------------
   Promo popup — email capture with a success state.
   Markup: sections/promo-popup.liquid

   When it opens (first of these to happen):
     - the delay elapses, counting only time the tab is actually
       visible — a page opened in the background, or prefetched by
       an ad network, no longer burns the delay unseen, and
     - the visitor scrolls past the scroll trigger, which is what
       usually fires first for ad traffic landing on a product page, or
     - desktop exit intent (pointer leaves the top of the window).

   Who sees it:
     - Once per visitor, remembered in localStorage under a key that
       includes the campaign id. With "Show again after" set, the flag
       is a timestamp and the popup returns once that many days pass.
       A legacy flag from the old build (the literal "1") is treated as
       expired, so those visitors are eligible again.

   Preview notes:
     - In the theme editor (Shopify.designMode) the once-per-visitor
       flag and the delay are ignored, and the popup re-initialises on
       shopify:section:load, so edits are always visible.
     - On any theme, adding ?popup=preview to the URL forces it open
       and ignores the seen flag. Use this to check an unpublished
       preview theme before enabling on live.
--------------------------------------------------------- */
(function () {
  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var FORCE = /[?&]popup=preview/.test(window.location.search);
  var DAY_MS = 86400000;

  function initPromoPopup (scope) {
    var popup = (scope || document).querySelector('[data-promo-popup]');
    if (!popup || popup.dataset.promoReady === '1') return;
    popup.dataset.promoReady = '1';

    var campaign = popup.getAttribute('data-campaign') || 'default';
    var storageKey = 'avadote_promo_' + campaign;
    var showOnce = popup.getAttribute('data-once') === 'true';
    var delay = parseInt(popup.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 5;
    var reshowDays = parseInt(popup.getAttribute('data-reshow-days'), 10);
    if (isNaN(reshowDays)) reshowDays = 0;
    var scrollPct = parseInt(popup.getAttribute('data-scroll'), 10);
    if (isNaN(scrollPct)) scrollPct = 0;
    var exitIntent = popup.getAttribute('data-exit-intent') === 'true';

    /* Never suppress or stall the popup while previewing. */
    var previewing = DESIGN_MODE || FORCE;
    if (previewing) { showOnce = false; delay = 0; }

    var panel = popup.querySelector('.promo-popup__panel');
    var signupView = popup.querySelector('[data-promo-view="signup"]');
    var successView = popup.querySelector('[data-promo-view="success"]');
    var form = popup.querySelector('form');
    var submit = popup.querySelector('[data-promo-submit]');
    var submitLabel = popup.querySelector('[data-promo-submit-label]');
    var errorEl = popup.querySelector('[data-promo-error]');
    var defaultLabel = submitLabel ? submitLabel.textContent : 'Continue';
    var lastFocus = null;

    function seen () {
      if (!showOnce) return false;
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return false;
        if (reshowDays <= 0) return true;
        var ts = parseInt(raw, 10);
        /* Anything that is not a real timestamp is a flag from the old
           build — let those visitors see the popup once more. */
        if (isNaN(ts) || ts < 1000000000000) return false;
        return (Date.now() - ts) < reshowDays * DAY_MS;
      } catch (e) { return false; }
    }
    function markSeen () {
      if (previewing) return;
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
    }

    /* ---- delay that only runs while the page is on screen ---- */
    var remaining = delay * 1000;
    var startedAt = 0;
    var timer = null;

    function clearTimer () {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }
    function pauseTimer () {
      if (!timer) return;
      remaining = Math.max(0, remaining - (Date.now() - startedAt));
      clearTimer();
    }
    function startTimer () {
      if (timer || popup.classList.contains('is-open')) return;
      if (document.hidden && !previewing) return;
      startedAt = Date.now();
      timer = window.setTimeout(function () { timer = null; open(); }, remaining);
    }

    /* ---- extra triggers, removed as soon as the popup opens ---- */
    function onScroll () {
      var doc = document.documentElement;
      var max = Math.max(document.body.scrollHeight, doc.scrollHeight) - window.innerHeight;
      if (max <= 0) return;
      var pct = ((window.pageYOffset || doc.scrollTop) / max) * 100;
      if (pct >= scrollPct) open();
    }
    function onMouseOut (e) {
      if (e.clientY <= 0 && !e.relatedTarget) open();
    }
    function addTriggers () {
      if (scrollPct > 0) window.addEventListener('scroll', onScroll, { passive: true });
      if (exitIntent && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseout', onMouseOut);
      }
    }
    function removeTriggers () {
      clearTimer();
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onMouseOut);
    }

    function open () {
      if (popup.classList.contains('is-open')) return;
      /* Opening behind a hidden tab would burn the one view the visitor
         gets — hold it until they are actually looking at the page. */
      if (document.hidden && !previewing) { remaining = 0; clearTimer(); return; }
      removeTriggers();
      lastFocus = document.activeElement;
      popup.hidden = false;
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (showOnce) markSeen();
      var focusable = panel && panel.querySelector('input, button');
      if (focusable) focusable.focus();
    }

    function close () {
      popup.classList.remove('is-open');
      popup.hidden = true;
      document.body.style.overflow = '';
      markSeen();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function showSuccess () {
      if (!successView) return;
      if (signupView) signupView.hidden = true;
      successView.hidden = false;
      markSeen();
    }

    function reset () {
      if (signupView) signupView.hidden = false;
      if (successView) successView.hidden = true;
      if (submit) submit.disabled = false;
      if (submitLabel) submitLabel.textContent = defaultLabel;
      if (errorEl) errorEl.hidden = true;
    }

    popup.querySelectorAll('[data-promo-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = '…';

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'text/html' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('signup failed');
            showSuccess();
          })
          .catch(function () {
            if (errorEl) errorEl.hidden = false;
            if (submit) submit.disabled = false;
            if (submitLabel) submitLabel.textContent = defaultLabel;
          });
      });
    }

    popup.promoApi = { open: open, close: close, reset: reset, showSuccess: showSuccess };

    /* Returned from a native (non-JS) post — open straight to success. */
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      open();
      showSuccess();
      return;
    }

    if (seen()) return;

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseTimer(); else startTimer();
    });
    /* Restored from the back/forward cache — pick the countdown back up. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) startTimer(); });

    addTriggers();
    startTimer();
  }

  function boot () { initPromoPopup(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: sections are re-rendered without a page load. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-promo-popup]') : null;
    if (!el && !(e.target.matches && e.target.matches('[data-promo-popup]'))) return;
    initPromoPopup(e.target);
    var popup = document.querySelector('[data-promo-popup]');
    if (popup && popup.promoApi) { popup.promoApi.reset(); popup.promoApi.open(); }
  });

  /* Theme editor: clicking the section in the sidebar re-opens it. */
  document.addEventListener('shopify:section:select', function () {
    var popup = document.querySelector('[data-promo-popup]');
    if (popup && popup.promoApi) { popup.promoApi.reset(); popup.promoApi.open(); }
  });
  document.addEventListener('shopify:section:deselect', function () {
    var popup = document.querySelector('[data-promo-popup]');
    if (popup && popup.promoApi && (window.Shopify && window.Shopify.designMode)) popup.promoApi.close();
  });
})();

/* ===========================================================
   CAROUSELS
   - Press ("As Seen On"): one feature at a time, auto-rotating.
   - Featured collection (carousel layout): a scrolling rail of product cards.
   Both re-init on shopify:section:load so the theme editor stays live.
   =========================================================== */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     Press carousel — one feature at a time
  --------------------------------------------------------- */
  function initPressCarousels (root) {
    (root || document).querySelectorAll('[data-press-carousel]').forEach(function (stage) {
      if (stage.dataset.pressReady === 'true') return;
      stage.dataset.pressReady = 'true';

      var slides = stage.querySelectorAll('[data-press-slide]');
      if (slides.length < 2) return; // a lone feature just sits there

      var dots = stage.querySelectorAll('[data-press-dot]');
      var prev = stage.querySelector('[data-press-prev]');
      var next = stage.querySelector('[data-press-next]');
      var interval = parseInt(stage.getAttribute('data-interval'), 10) || 6000;
      var autoplay = stage.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      var index = 0;
      var timer = null;

      function show (i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
          el.setAttribute('tabindex', on ? '0' : '-1');
        });
        dots.forEach(function (d, idx) {
          d.setAttribute('aria-current', idx === index ? 'true' : 'false');
        });
      }

      function stop () { if (timer) { clearInterval(timer); timer = null; } }
      function start () {
        stop();
        if (!autoplay) return;
        timer = setInterval(function () { show(index + 1); }, interval);
      }

      dots.forEach(function (d, idx) {
        d.addEventListener('click', function () { show(idx); start(); });
      });
      if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); start(); });

      /* pause while someone is actually reading it */
      stage.addEventListener('mouseenter', stop);
      stage.addEventListener('mouseleave', start);
      stage.addEventListener('focusin', stop);
      stage.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      show(0);
      start();
    });
  }

  /* ---------------------------------------------------------
     Product carousel — a scroll-snapped rail; the arrows just
     nudge it, so swipe and keyboard still work without JS
  --------------------------------------------------------- */
  function initProductCarousels (root) {
    (root || document).querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;

      var section = carousel.closest('.shop') || carousel;
      var prev = section.querySelector('[data-carousel-prev]');
      var next = section.querySelector('[data-carousel-next]');

      function step () {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function sync () {
        var max = track.scrollWidth - track.clientWidth;
        section.classList.toggle('has-overflow', max > 2);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      if (window.ResizeObserver) new ResizeObserver(sync).observe(track);

      sync();
    });
  }

  function initCarousels (root) {
    initPressCarousels(root);
    initProductCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  } else {
    initCarousels();
  }
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();

/* ===========================================================
   MEMBERS AREA — copy a perk code to the clipboard
   =========================================================== */
(function () {
  function initCodeCopy (root) {
    (root || document).querySelectorAll('[data-copy-code]').forEach(function (btn) {
      if (btn.dataset.copyReady === 'true') return;
      btn.dataset.copyReady = 'true';

      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy-code') || '';
        var hint = btn.querySelector('.members__code-hint');

        var done = function (ok) {
          if (!hint) return;
          hint.textContent = ok ? 'Copied' : 'Select it';
          btn.classList.add('is-copied');
          setTimeout(function () {
            hint.textContent = 'Copy';
            btn.classList.remove('is-copied');
          }, 2000);
        };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(function () { done(true); },
                                                   function () { done(false); });
        } else {
          /* older browsers, and any context where the clipboard is blocked */
          try {
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            done(document.execCommand('copy'));
            document.body.removeChild(ta);
          } catch (e) { done(false); }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCodeCopy(); });
  } else {
    initCodeCopy();
  }
  document.addEventListener('shopify:section:load', function (e) { initCodeCopy(e.target); });
})();
